import { render } from "./BanksListView.vue?vue&type=template&id=50892e51"
import script from "./BanksListView.vue?vue&type=script&lang=js"
export * from "./BanksListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__